import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cross-price-elasticity-calculator',
  component: () => import('../../routes/CrossPriceElasticityCalculator.svelte'),
  card: {
    id: 'cross-price-elasticity-calculator',
    title: 'Cross-Price Elasticity Calculator',
    description: 'Measure how the demand for one good responds to price changes in another good — substitutes or complements.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/cross-price-elasticity-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Cross-Price Elasticity Calculator – Substitute & Complement Goods',
    description: 'Free cross-price elasticity calculator. Measure how demand for one good responds to price changes in another good. Identifies substitutes, complements, and unrelated goods.',
  },
};

export default meta;
